import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';
@Pipe({
    name: 'escalaProyecto',
})
export class EscalaPipe implements PipeTransform {
    transform(value: number): string | null {
        if (value > 0 && value <= 500) {
            return 'Pequeña escala';
        } else if (value > 500 && value <= 5000) {
            return 'Mediana escala';
        } else if (value > 5000) {
            return 'Gran escala';
        } else {
            return 'Sin área neta';
        }
    }
}
